
//----------------------------------
// Imports
//----------------------------------
// import moment from 'moment';

//----------------------------------
// Internal Methods
const internal = {
//----------------------------------
  getListObjectProperty: (obj, property) => {
    if (obj.transformed && obj.transformed[property] !== undefined && obj.transformed[property]?.constructor !== Object) {
      return obj.transformed[property];
    }
    if (obj.source && obj.source[property]) {
      return obj.source[property];
    }
    return obj[property];
  },
};

//---------------------------------------------------
//
//  Exported Class
//
//---------------------------------------------------
export default class Sort {
  static default(a, b) {
    return (a || '').localeCompare(b || '');
  }

  static alpha(a, b) {
    return Sort.default(a, b);
  }

  static date(a, b) {
    const date1 = a || '';
    const date2 = b || '';
    // eslint-disable-next-line no-nested-ternary
    return (date1 <= date2) ? -1 : ((date1 >= date2) ? 1 : 0);
  }

  static number(a, b) {
    return (a || 0) - (b || 0);
  }

  static boolean(a, b) {
    if (a === b) {
      return 0;
    }
    return a ? -1 : 1;
  }

  static chained(first, second) {
    return (a, b) => {
      const res = first(a, b);
      return (res === 0) ? second(a, b) : res;
    };
  }

  static absoluteOrdering(sort, ascending) {
    return ascending ? sort : (a, b) => -sort(a, b);
  }

  static emptyToBottom(a, b) {
    if (a === b) return 0;
    if (a === '' || a === undefined || a === null) return 1;
    if (b === '' || b === undefined || b === null) return -1;
    return 0;
  }

  static get list() {
    return {
      default: ({ property, ascending }) => {
        const sortFn = Sort.chained(Sort.absoluteOrdering(Sort.emptyToBottom, ascending), Sort.default);
        return (a, b) => {
          const propA = internal.getListObjectProperty(a, property);
          const propB = internal.getListObjectProperty(b, property);
          return sortFn(propA, propB);
        };
      },
      // eslint-disable-next-line no-unused-vars
      branch: ({ property, ascending }) => {
        const sortFn = Sort.chained(Sort.absoluteOrdering(Sort.emptyToBottom, ascending), Sort.default);
        return (a, b) => {
          const propA = a?.branch?.name || '-';
          const propB = b?.branch?.name || '-';
          return sortFn(propA, propB);
        };
      },
      psychologist: ({ property, ascending }) => {
        const sortFn = Sort.chained(Sort.absoluteOrdering(Sort.emptyToBottom, ascending), Sort.default);
        return (a, b) => {
          const propA = a[property].name;
          const propB = b[property].name;
          return sortFn(propA, propB);
        };
      },
      alpha: ({ property, ascending }) => {
        const sortFn = Sort.chained(Sort.absoluteOrdering(Sort.emptyToBottom, ascending), Sort.alpha);
        return (a, b) => {
          const propA = internal.getListObjectProperty(a, property);
          const propB = internal.getListObjectProperty(b, property);
          return sortFn(propA, propB);
        };
      },
      date: ({ property }) => (a, b) => {
        const valA = a[property];
        const valB = b[property];
        return Sort.date(valA, valB);
      },
      number: ({ property }) => (a, b) => {
        const valA = a[property];
        const valB = b[property];
        return Sort.number(valA, valB);
      },
      boolean: ({ property }) => (a, b) => {
        const propA = internal.getListObjectProperty(a, property);
        const propB = internal.getListObjectProperty(b, property);
        return Sort.boolean(propA, propB);
      },
      chained: (first, second) => sortOpts => Sort.chained(first(sortOpts), second(sortOpts)),
    };
  }
}
